import React, { useEffect, useState } from "react";
import CreateTemplate from "../Component/Template/CreateTemplate";
import TemplateSetup from "../Component/Template/TemplateSetup";
import Footer from "../Component/Template/Footer";
import ShowStages from "./ShowStages";
import Sidebar from "../Sidebar/Sidebar";
import { useAPI } from "../Context/MyContext";
import { useNavigate, useParams } from "react-router-dom";
import { useStateContex } from "../Context/UseStateContet";

const CreateTemplates = () => {

  const { createTemplate, getUserWabaIds } = useAPI();
  const { wabaId } = useParams();


  const navigate = useNavigate();
  const [stage, setStage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState("Marketing");
  const [selectedSubCat, setSelectedSubCat] = useState("Default");
  const [mediaId, setMediaId] = useState(null);
  const [template, setTemplate] = useState({
    name: "",
    language: "English",
    components: [],
  });




  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const [showPreview, setShowPreview] = useState();
  const [handleNext, setHandleNext] = useState();
  const [wabaIds, setWabaIds] = useState([]);
  const { selectedWabaId } = useStateContex()
  // const [selectedWabaId, setSelectedWabaId] = useState("");

  // 
  if (!wabaId) {
    navigate("/template");
  }
  //   


  useEffect(() => {
    const fetchWabaIds = async () => {
      try {
        const res = await getUserWabaIds();
        //  console.log("API response for WABA IDs:", res);
        setWabaIds(res.wabaIds || []);

        if (res.wabaIds?.length) {
          // Set the first WABA id by default
          // setSelectedWabaId(res.wabaIds[0]);
        } else {
          console.warn("⚠️ No WABA IDs available for this user");
        }
      } catch (err) {
        console.error("Failed to load WABA IDs:", err);
      }
    };

    fetchWabaIds();
  }, [getUserWabaIds]);



  // payload
  const buildPayload = () => {
    return {
      name: template.name || "default_template_name",
      language: template.language === "English" ? "en_US" : template.language,
      category: selectedCategory.toUpperCase(),
      components: template.components || [],
      wabaId: wabaId,
      mediaId: mediaId,
    };
  };

  useEffect(() => {
    const payload = buildPayload();
    // console.log("my payload is", JSON.stringify(payload, null, 2));
  }, [
    template.name,
    template.language,
    JSON.stringify(template.components),
    selectedCategory,
    selectedSubCat,
  ]);

  const handleSendTemplate = async () => {
    const payload = buildPayload();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const res = await createTemplate(payload);
      if (res.success) {
        setSuccess("Template created successfully!");
        navigate("/template");
        return true;
      } else {
        setError("Failed to create template");
      }
    } catch (err) {
      setError("Error creating template");
      console.error("Error creating template:", err);
    } finally {
      setLoading(false);
    }
    return false;
  };

  // On Submit
  const onSubmit = async () => {
    const isSuccess = await handleSendTemplate();
    if (isSuccess) {
      setStage(3);
    }
  };

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <div className="h-screen bg-gray-100 flex-shrink-0">
        <Sidebar />
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col bg-gray-100 h-screen">

        {/* Scrollable Content Area */}
        <div className="flex-1 overflow-y-auto">
          <ShowStages stage={stage} setStage={setStage} />

          {/* Stage Specific Content */}
          {stage === 1 ? (
            <TemplateSetup
              setSelectedSubCat={setSelectedSubCat}
              setSelectedCategory={setSelectedCategory}
              selectedCategory={selectedCategory}
              selectedSubCat={selectedSubCat}
              setHandleNext={setHandleNext}
            />
          ) : stage === 2 ? (
            <CreateTemplate
              selectedCategory={selectedCategory}
              selectedSubCat={selectedSubCat}
              template={template}
              setTemplate={setTemplate}
              setShowPreview={setShowPreview}
              showPreview={showPreview}
              setMediaId={setMediaId}
            />
          ) : (
            <>Stage 3</>
          )}
        </div>

        {/* Fixed Footer */}
        <div className="shrink-0 bg-white border-t">
          <Footer
            stage={stage}
            setStage={setStage}
            onSendTemplate={onSubmit}
          />
        </div>
      </div>

      {/* Fullscreen Loader Overlay */}
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
            <p className="text-white mt-3 text-sm">Creating Template...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateTemplates;
